import React, { useState } from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import LatestWork from '../components/LatestWork';
import Portfolio from '../components/Portfolio';
import About from '../components/About';
import Contact from '../components/Contact';
import Modal from '../components/Modal';
import '../styles/HomePage.css';

const HomePage = () => {
  const [selectedItem, setSelectedItem] = useState(null);

  const handleItemClick = (item) => {
    setSelectedItem(item);
  };

  const handleCloseModal = () => {
    setSelectedItem(null);
  };

  return (
    <div className="homepage">
      <Header />
      <HeroSection />
      <LatestWork />
      <Portfolio onItemClick={handleItemClick} />
      <About />
      <Contact />
      {selectedItem && (
        <Modal item={selectedItem} onClose={handleCloseModal} />
      )}
    </div>
  );
};

export default HomePage;
